import React from "react";
import styles from "./forbidden.module.scss";
import Layout from "../../Layout";
import logo from "./forbidden-logo.svg";
import { Link } from "react-router-dom";

function Forbidden() {
  return (
    <Layout>
      <div className={styles.wrapper}>
        <img src={logo} alt="Forbidden" />
        <h2 className={styles.title}>
          You don't have permission to access this page.
        </h2>
        <p className={styles.text}>
          If you think this is a mistake, contact support
        </p>
        <Link to="/" className={`btn onboard-entity ${styles.cta}`}>
          Back To Home Page
        </Link>
      </div>
    </Layout>
  );
}

export default Forbidden;
